import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import {
  patientStatusLabel,
  isPatientMarkedInactiveStatus,
} from '../../../lib/patientStatus';

const PatientCard = ({ patient, isSelected, onSelect }) => {
  const navigate = useNavigate();

  const handleViewProfile = () => {
      navigate(`/patient-profile/${patient?.dbId}`);
  };

  const handleCreateCase = () => {
    navigate('/case-detail', { state: { patientId: patient?.id, mode: 'create' } });
  };

  const getStatusColor = (status) => {
    if (isPatientMarkedInactiveStatus(status))
      return 'bg-muted text-muted-foreground';
    if (status === 'flagged') return 'bg-warning/10 text-warning';
    return 'bg-success/10 text-success';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-card transition-shadow duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => onSelect(patient?.id, e?.target?.checked)}
            className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary focus:ring-offset-2"
          />
          <div className="w-12 h-12 rounded-full bg-primary/10 text-primary flex items-center justify-center font-medium text-lg">
            {patient?.initials}
          </div>
          <div>
            <h3 className="text-base font-semibold text-foreground">{patient?.name}</h3>
            <p className="text-xs text-muted-foreground">ID: {patient?.id}</p>
          </div>
        </div>
        <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(patient?.status)}`}>
          {patientStatusLabel(patient?.status)}
        </span>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Mail" size={16} className="text-muted-foreground" />
          <span className="truncate">{patient?.email}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Phone" size={16} className="text-muted-foreground" />
          <span>{patient?.phone}</span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4 pb-4 border-b border-border">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Inscription</p>
          <p className="text-sm font-medium text-foreground">{patient?.registrationDate}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Dernière visite</p>
          <p className="text-sm font-medium text-foreground">{patient?.lastVisit}</p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-lg font-semibold text-foreground">{patient?.activeCases}</span>
          <span className="text-xs text-muted-foreground">cas actifs</span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleViewProfile}
            iconName="Eye"
            iconPosition="left"
          >
            
          </Button>
      
        </div>
      </div>
    </div>
  );
};

export default PatientCard;